import { init } from '_trackers';

export const initTracker = () => {
    init({ appName: 'Sina' });
};
